<template>
  <div>
  <b-tab>
    <template #title>
      {{ role.name || "Role" + (indexRole + 1) }}
      <span class="delete-tab" @click="removeRole(indexRole)">X</span>
    </template>
    <indica-form
      ref="role"
      table-name="AccountRoles"
      :save-to-store="true"
      store-name="roles"
      :show-submit="false"
      :show-many="false"
      :show-edit="false"
      :show-return="false"
      :filter-selector="filterRoles"
      :store-index="indexRole"
      :show-extra-sections="false"
    />
    <configuration-wizard-access-controls
      v-if="
        getAllStoreInfo.roles[indexRole] &&
        getAllStoreInfo.business &&
        getAllStoreInfo.roles[indexRole].accountRoleTemplateId
      "
      ref="access"
      :store-index="indexRole"
      :account-role-template="
        getAllStoreInfo.roles[indexRole].accountRoleTemplateId
      "
      :business-name="
        getAllStoreInfo.business.selfAssessment_general_business_companyName
      "
    />
  </b-tab>
  </div>
</template>
<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { mapGetters } from "vuex";
import IndicaForm from "@/utils/forms/indica-form";
import ConfigurationWizardAccessControls
  from "@/components/modules/administration/businessCreation/ConfigurationWizardAccessControls";

export default {
  name: "RoleToCreate",
  components: {IndicaForm,ConfigurationWizardAccessControls},
  data (){
    return {
      filterRoles: [
        {
          fieldName: "accountRoleTemplateId",
          filter: {
            roleTypeId: {
              inq: ["5b6db76f93d675d276f4095f", "5b6db76b93d675d276f4095e"],
            },
          },
        },
      ],
    }
  },
  props: {
    role: {
      type: Object,
      default: () => {},
    },
    indexRole: {
      type: Number,
      default: 0,
    },
  },
  watch: {},
  methods: {
    removeRole(index) {
      const payload = {};
      payload["storeName"] = "roles";
      payload["index"] = index;
      this.$store.dispatch("removeFromArray", payload);
    },
  },
  computed: {
    ...mapGetters(["getAllStoreInfo"]),
  },
};
</script>

<style lang="scss" scoped>
.new-id {
  font-size: 11px;
  color: gray;
}

.error {
  color: red;
}

.ok {
  color: green;
}

.message-error {
  font-size: 16px;
  color: red;
  text-align: center;
  padding: 30px;
}

.delete-tab {
  color: red;
  font-weight: bold;
  margin-left: 5px;
  padding: 2px 5px;
  font-size: 15px;
  transition: 0.3s;

  &:hover {
    font-size: 13px;
  }
}
</style>
